<badge icon="group" [theme]="color" [hover]="hover">
  <span class="students-count">{{ count }}</span>
</badge>
